export default ({ isOneSize, isNoSize }) => !isOneSize && !isNoSize;
